<template>
  <basic-container>
    <mc-exception403 />
  </basic-container>
</template>


<script>
import McException403 from "./../../../blocks/mc-exception403/index.js";
export default {
  components: {
    McException403
  }
};
</script>
